// Selectors which are used commonly across all the redux slices.

export const selectEntitiesByAdfitNo = (stateSlice, adfitNo) => {
  try {
    if (stateSlice.currentAccountAdfitNo === adfitNo) {
      return stateSlice.entities;
    }
    return null;
  } catch (e) {
    return null;
  }
};
